<template>
  <a-modal
    :title="title"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @cancel="$emit('close')"
    @ok="handleSubmit"
    destroyOnClose
  >
    <div class="right">
      <!-- 材料题 -->
      <div class="topicBox" style="margin-bottom:15px" v-if="form.type =='material'">
        <div class="title mb20x" >【材料题】</div>
        <a-input type="text" placeholder="题干标题" v-model="data.stemTitle"/>
        <a-textarea placeholder="请输入题干" :autoSize="{ minRows: 6 }" style="background:#eee;margin-top:20px;padding:10px" v-model="stem"/>
      </div>
      <!-- 单选题 -->
      <div class="topicBox" v-if="form.type =='single_choice' || ( form.type =='material' && data.currentIndex == 'single_choice' )">
        <div class="title">
          <span style="flex: 1">【单选题】</span>
          <a-button @click="insertBjAnswer">插入答案位置</a-button>
        </div>
        <div class="bottomLine inputWrap">
          <Editor ref="tinymceChoice" :key="form.type" :value="form.title" @input="handleNames" placeholder="请输入题目内容" style="min-height: 200px;"
                  v-decorator="['content', { initialValue: form.title, rules: [{ required: true, message: '请输入题目内容' }] }]"
          ></Editor>
        </div>
        <div class="bottomLine optionsItem">
          <div class="title dpFlex">
            <span>请编辑题目选项</span>
          </div>
          <a-radio-group v-model="form.consult" class="w100pct">
            <ul>
              <li v-for="(item, index) in form.content" :key = "index">
                <a-radio :value="item.key"><span>{{item.key}}:</span></a-radio>
                <a-input placeholder="请输入" class="noBorder" v-model="form.content[index].item"/>
                <div v-if="index > 0">
                  <a-icon type="close" class="csP" @click="removeChoice('single_choice')"/>
                </div>
              </li>
              <li>
                <a-button class="btn border" style="height:35px;width:100%" @click="addchoice('single_choice')"><a-icon type="plus"/>添加</a-button>
              </li>
            </ul>
          </a-radio-group>
        </div>
        <div class="answer">
          <div class="title">参考答案：</div>
          <div class="import">{{form.consult}}</div>
          <div class="title">师探解析：</div>
          <div class="import">
            <a-textarea placeholder="请输入解析" :autoSize="{ minRows: 6 }" style="background:#eee;margin-top:20px;padding:10px" v-model="form.analysis"/>
          </div>
          <div class="title">本题考点：</div>
          <div class="import">
            <a-input placeholder="请输入考点" class="noBorder" v-model="form.point"/>
          </div>
        </div>
      </div>
      <!-- 多选题 -->
      <div class="topicBox" v-if="form.type =='multiple_choice' || ( form.type =='material' && data.currentIndex == 'multiple_choice' )">
        <div class="title">
          <span style="flex: 1">【多选题】</span>
          <a-button @click="insertBjAnswer">插入答案位置</a-button>
        </div>
        <div class="bottomLine inputWrap">
          <Editor :key="form.type" :value="form.title" @input="handleNames" placeholder="请输入题目内容" style="min-height: 200px;"
                  v-decorator="['content', { initialValue: form.title, rules: [{ required: true, message: '请输入题目内容' }] }]"
          ></Editor>
          <!--                            <a-textarea placeholder="请输入题目" style="padding:10px" :autoSize="{ minRows: 3, maxRows: 6 }" v-model="form.title"/>-->
          <!--                            <UploadImg @updateImg="(data)=>{form.titleImg = data}" :imageUrl="form.titleImg"/>-->
        </div>
        <div class="bottomLine optionsItem">
          <div class="title">请编辑题目选项</div>
          <a-checkbox-group @change="onChange" style="width:100%" v-model="form.consult">
            <ul>
              <li v-for="(item, index) in form.content" :key = "index">
                <a-checkbox :value="item.key" class="w58x"><span>{{item.key}}:</span></a-checkbox>
                <a-input placeholder="请输入" class="noBorder" v-model="form.content[index].item"/>
                <div v-if="index > 0">
                  <a-icon type="close" class="csP" @click="removeChoice('multiple_choice')"/>
                </div>
              </li>
              <li>
                <a-button class="btn border" style="height:35px;width:100%" @click="addchoice('multiple_choice')"><a-icon type="plus"/>添加</a-button>
              </li>
            </ul>
          </a-checkbox-group>
        </div>
        <div class="answer">
          <div class="title">参考答案：</div>
          <div class="import">
            <span v-for="(item , index) in form.consult" :key="index" class="mr10px">{{item}} <span v-if="index != form.consult.length-1">,</span></span>
          </div>
          <div class="title">师探解析：</div>
          <div class="import">
            <a-textarea placeholder="请输入解析" :autoSize="{ minRows: 6 }" style="background:#eee;margin-top:20px;padding:10px" v-model="form.analysis"/>
          </div>
          <div class="title">本题考点：</div>
          <div class="import"><a-input placeholder="请输入考点" class="noBorder" v-model="form.point"/></div>
        </div>
      </div>
      <!-- 判断题 -->
      <div class="topicBox" v-if="form.type =='jud_question' || ( form.type =='material' && data.currentIndex == 'jud_question' )">
        <div class="title">
          <span>【判断题】</span>
        </div>
        <div class="bottomLine inputWrap">
          <Editor :key="form.type" :value="form.title" @input="handleNames" placeholder="请输入题目内容" style="min-height: 200px;"
                  v-decorator="['content', { initialValue: form.title, rules: [{ required: true, message: '请输入题目内容' }] }]"
          ></Editor>
        </div>
        <div class="bottomLine optionsItem">
          <div class="title">请编辑题目选项</div>
          <a-radio-group v-model="form.consult">
            <ul>
              <li>
                <a-radio :value="'1'"><span>对</span></a-radio>
              </li>
              <li>
                <a-radio :value="'2'"><span>错</span></a-radio>
              </li>
            </ul>
          </a-radio-group>
          <template v-if="form.consult === '2'">
            <div class="title">请编辑原因（参考答案）：</div>
            <a-textarea placeholder="原因" :autoSize="{ minRows: 3, maxRows: 6 }" v-model="form.consultCont"/>
            <div style="text-align:right;color:#999999;font-size:14px">{{form.consultCont.length}}/300</div>
          </template>
        </div>
        <div class="answer">
          <div class="title">参考答案：</div>
          <div class="import"><span v-if="form.consult== 1">对</span><span v-if="form.consult== 2">错</span><span v-if="form.consultCont">，</span>{{form.consultCont}}</div>
          <div class="title">师探解析：</div>
          <div class="import">
            <a-textarea placeholder="请输入解析" :autoSize="{ minRows: 6 }" style="background:#eee;margin-top:20px;padding:10px" v-model="form.analysis"/>
          </div>
          <div class="title">本题考点：</div>
          <div class="import"><a-input placeholder="无" class="noBorder" v-model="form.point"/></div>
        </div>
      </div>
      <!-- 填空题 -->
      <div class="topicBox" v-if="form.type =='fill' || ( form.type =='material' && data.currentIndex == 'fill' )">
        <div class="title">
          <span style="flex: 1">【填空题】</span>
          <a-button @click="insertBjAnswer">插入答案位置</a-button>
        </div>
        <div class="bottomLine inputWrap">
          <Editor :key="form.type" :value="form.title" @input="handleNames" placeholder="请输入题目内容" style="min-height: 200px;"
                  v-decorator="['content', { initialValue: form.title, rules: [{ required: true, message: '请输入题目内容' }] }]"
          ></Editor>
        </div>
        <div class="answer">
          <div class="title">参考答案：</div>
          <div class="import"><a-input placeholder="请输入参考答案" class="noBorder" v-model="form.consult"/></div>
          <div class="title">师探解析：</div>
          <div class="import"><a-textarea placeholder="请输入解析" :autoSize="{ minRows: 6 }" style="background:#eee;margin-top:20px;padding:10px" v-model="form.analysis"/></div>
          <div class="title">本题考点：</div>
          <div class="import"><a-input placeholder="请输入考点" class="noBorder" v-model="form.point"/></div>
        </div>
      </div>
      <!-- 论述题 -->
      <div class="topicBox" v-if="form.type =='answer' || ( form.type =='material' && data.currentIndex == 'answer' )">
        <div class="title">
          <span>【{{ form.typeName }}】</span>
        </div>
        <div class="bottomLine inputWrap">
          <Editor :key="form.type"  :value="form.title" @input="handleNames" placeholder="请输入题目内容" style="min-height: 200px;"
                  v-decorator="['content', { initialValue: form.title, rules: [{ required: true, message: '请输入题目内容' }] }]"
          ></Editor>
        </div>
        <div class="answer">
          <div class="title">参考答案：</div>
          <div class="import">
            <Editor @input="handleInput" :key="'consult' + form.type" :value="form.consult" placeholder="请输入参考答案" style="min-height: 200px"></Editor>
          </div>
          <div class="title">师探解析：</div>
          <div class="import"><a-textarea placeholder="请输入解析" :autoSize="{ minRows: 6 }" style="background:#eee;margin-top:20px;padding:10px" v-model="form.analysis"/></div>
          <div class="title">本题考点：</div>
          <div class="import"><a-input placeholder="无" class="noBorder" v-model="form.point"/></div>
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
import Editor from '@/components/Tinymce'
import { uploadImg, add_question_bank, edit_question_bank } from '@/libs/api'
import * as http from '@/libs/analysis'
const defaultAllChoice = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'G', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'I', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
export default {
  components: { Editor },
  name: 'addOpencourse',
  props: [ 'visible', 'data', 'type' ],
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  watch:{
    visible(val){
      if(val){
        if(this.data.length == 0){
          this.title = "新增试题"
          switch (this.type) {
            case 'single_choice':
              this.form = {
                analysis: '',
                bookId: '',
                bookKey: '',
                cate_id: '',
                consult: '',
                consultCont: '',
                content: [],
                currentIndex: 0,
                duan: '',
                hang: '',
                id: '',
                name: '',
                point: '',
                q_id: '',
                status: 1,
                stemTitle: '',
                task_id: '',
                title: '',
                type: "single_choice",
                ye: ''
              }
              break;
            default:

              break;
          }
        }else{
          this.title = "编辑试题"
          this.form = this.data
        }
      }
    }
  },
  data(){
    return{
      confirmLoading: false,
      loading: false,
      form:[],
      options:[],
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 18 },
      },
      url:''
    }
  },
  methods:{
    saveItem(){},
    insertBjAnswer(){
      this.$refs.tinymceChoice.insertBj();
    },
    handleNames (html) {
      this.form.title = html
    },
    handleInput (html) {
      this.form.consult = html
    },
    addchoice(type){
      console.log(type)
      // Ensure form.content is an array
      if (!Array.isArray(this.form.content)) {
        this.form.content = [];
      }
      
      // Get the next available letter
      let nextIndex = this.form.content.length;
      if (nextIndex >= defaultAllChoice.length) {
        this.$message.warning('已达到最大选项数量');
        return;
      }
      
      let nextKey = defaultAllChoice[nextIndex];
      
      // Create a new array with the added option
      this.form.content = [
        ...this.form.content,
        { 'key': nextKey, 'item': '' }
      ];
      
      // Trigger Vue's reactivity
      this.$forceUpdate();
    },
    removeChoice(type){
      console.log(type);
      
      // Create a new array without the last item
      this.form.content = this.form.content.slice(0, -1);
      
      // If the removed option was selected, update the selected value
      const lastKey = defaultAllChoice[this.form.content.length];
      if (this.form.consult === lastKey) {
        this.form.consult = '';
      }
      
      // Trigger Vue's reactivity
      this.$forceUpdate();
    },
    dealArr(data){
      data.forEach(el => {
        if(!el.son.length){
          delete el.son
        }
        if(el.son &&  el.son.length){
          this.dealArr(el.son)
        }
      })
    },
    handleSubmit(){
      this.confirmLoading = true
      if(!this.form.id){
        http.add_question_bank(this.form).then(res=>{
          this.$emit('close')
          this.$emit('update')
          this.confirmLoading = false
        }).catch((error)=>{
          console.log(error)
          this.confirmLoading = false
        })
      }else{
        http.edit_question_bank(this.form).then(res=>{
          this.$emit('close')
          this.$emit('update')
          this.confirmLoading = false
        }).catch((error)=>{
          console.log(error)
          this.confirmLoading = false
        })
      }
    },
    beforeUpload(){
    },
    customRequest(data){
      let formData = new FormData()
      formData.append('file',data.file)
      uploadImg(formData).then(res=>{
        if(res){
          this.imageUrl=res.fileUrl
        }
      },error=>{
        console.log(error)
      })
    },
    handleChange(){

    }
  }
}
</script>

<style lang="less" scoped>
.right{
  flex: 1;
  overflow: auto;
  .topicBox{
    background: #fff;
    border-radius: 4px;
    .title{
      display: flex;
      line-height: 2.5;
      font-size: 16px;
      border-bottom: 1px solid #eeeeee;
    }
    .inputWrap{
      padding: 10px 0;
      .ant-input{
        font-size: 16px;
        background: #eee;
      }
    }
    .optionsItem{
      padding: 15px 0;
      .title{
        font-size: 16px;
        color: #999999;
        border: none;

      }
      ul{
        margin-bottom: 0;
        li{
          padding: 10px 0;
          display: flex;
          align-items: center;
          >*{
            margin-right: 10px
          }
          span{
            color: #5180e0
          }
        }
      }
      .more{
        text-align:center;
        cursor: pointer;
        color: #999;
        padding: 5px 0 10px
      }
    }
    .answer{
      padding-top: 10px;
      .title{
        line-height: 30px;
        color: #333;
        border-bottom: none;
        margin: 5px 0;
      }
      .import{
        line-height: 30px;
        color: #999;
        .ant-input{
          padding-left: 0
        }
      }
    }
  }
}
</style>
